import React, {Component} from 'react';
import _ from 'lodash';
import TextEditor from "../../../elements/forms/wysiwyg_field";
import DatePicker from "react-datepicker";
import * as moment from "moment";

class ServiceDirectoryForm extends Component {
	render() {
		return <div className="directory-form">
			<form id="placeForm">
				<div className="field is-grouped">
					<div className="control is-expanded">
						<label htmlFor="place" className="label">Institución</label>
						<div className="select">
							<select ref="place" id="place">
								<option value={0} selected disabled>--- Institución ---</option>
								{_.map(this.props.places, (place, p) => {
									return <option value={place.id} key={p}>{place.name}</option>
								})}
							</select>
						</div>
					</div>
					
					<div className="control is-expanded">
						<label htmlFor="level" className="label">Nivel de gobierno</label>
						<div className="select">
							<select name="level" ref="level" id="level">
								<option value={0} selected disabled>--- Nivel de gobierno ---</option>
								<option value="Federal">Federal</option>
								<option value="Estatal">Estatal</option>
								<option value="Municipal">Municipal</option>
							</select>
						</div>
					</div>

					<div className="control is-expanded">
						<label htmlFor="type" className="label">Tipo</label>
						<div className="select">
							<select ref="type" id="type">
								<option value={0} selected disabled>--- Tipo ---</option>
								<option value="Programa">Programa</option>
								<option value="Servicio">Servicio</option>
							</select>
						</div>
					</div>
				</div>

				<div className="title is-6">Población Objetivo</div>
				<div className="field is-grouped">
					<div className="control">
						<label htmlFor="objective1" className="checkbox">
							<input type="checkbox" onChange={(e) => this.setCheckbox(e)} id="objective1" ref="objective1" value="Mujeres" />
							Mujeres
						</label>
					</div>
					<div className="control">
						<label htmlFor="objective2" className="checkbox">
							<input type="checkbox" onChange={(e) => this.setCheckbox(e)} id="objective2" ref="objective2" value="Madres solteras" />
							Madres solteras
						</label>
					</div>
					<div className="control">
						<label htmlFor="objective3" className="checkbox">
							<input type="checkbox" onChange={(e) => this.setCheckbox(e)} id="objective3" ref="objective3" value="Migrantes" />
							Migrantes
						</label>
					</div>
					<div className="control">
						<label htmlFor="objective4" className="checkbox">
							<input type="checkbox" onChange={(e) => this.setCheckbox(e)} id="objective4" ref="objective4" value="Adultos mayores" />
							Adultos mayores
						</label>
					</div>
					<div className="control">
						<label htmlFor="objective5" className="checkbox">
							<input type="checkbox" onChange={(e) => this.setCheckbox(e)} id="objective5" ref="objective5" value="Mujeres con discapacidad" />
							Mujeres con discapacidad
						</label>
					</div>
					<div className="control">
						<label htmlFor="objective6" className="checkbox">
							<input type="checkbox" onChange={(e) => this.setCheckbox(e)} id="objective6" ref="objective6" value="Población Objetivo" />
							Mujeres
						</label>
					</div>
				</div>

				<div className="field is-grouped">
					<div className="control is-expanded">
						<label htmlFor="name" className="label">Nombre del programa / servicio</label>
						<input type="text" id="name" ref="name" className="input" placeholder="Nombre del programa o servicio" />
					</div>

					<div className="control">
						<label htmlFor="start_date" className="label">Vigente desde</label>
						<DatePicker className="input" name="start_date" ref="start_date" dateFormat="YYYY-MM-DD" selected={this.state.dates.start_date} placeholderText={moment().format('YYYY-MM-DD')} onChange={(value) => this.setInput('start_date', moment(value).format('YYYY-MM-DD'))} />
					</div>

					<div className="control">
						<label htmlFor="end_date" className="label">Vigente Hasta</label>
						<DatePicker className="input" name="end_date" ref="end_date" dateFormat="YYYY-MM-DD" selected={this.state.dates.end_date} placeholderText={moment().format('YYYY-MM-DD')} onChange={(value) => this.setInput('end_date', moment(value).format('YYYY-MM-DD'))} />
					</div>
				</div>

				<div className="field">
					<div className="control">
						<label htmlFor="description" className="label">Descripción</label>
						<TextEditor ref="description" id="descirption" placeholder="Descripción del programa o servicio" value={this.state.description} onChange={(value) => this.setDescription(value)} />
					</div>
				</div>

				<div className="field">
					<div className="control">
						<label htmlFor="offers" className="label">Apoyos que ofrece</label>
						<TextEditor id="offers" ref="offers" placeholder="Apoyos que ofrece" value={this.state.offers} onChange={(value) => this.setOffers(value)} />
					</div>
				</div>

				<div className="field is-grouped is-grouped-right">
					<div className="control">
						<button onClick={(e) => this.saveEntry(e)} className="button is-cdm-blue" type="button">Guardar</button>
					</div>
				</div>
			</form>
		</div>
	}

	constructor() {
		super();
		this.state = {
			dates: {
				start_date: undefined,
				end_date: undefined
			},
			offers: '',
			description: '',
			objective: []
		}
		this.setInput = this.setInput.bind(this);
		this.setOffers = this.setOffers.bind(this);
		this.setDescription = this.setDescription.bind(this);
		this.setCheckbox = this.setCheckbox.bind(this);
	}

	setCheckbox(el) {
		let newArr = this.state.objective;
		if(el.target.checked) {
			newArr.push({name: el.target.value});
		}else{
			newArr.filter(o => o === el.target.value);
		}
		return this.setState({
			objective: newArr
		});
	}

	setOffers(value) {
		return this.setState({ offers: value });
	}

	setDescription(value) {
		return this.setState({ description: value });
	}

	setInput(field, value) {
		let newvalues = {};
		if(field === 'start_date') {
			newvalues = {
				start_date: moment(value),
				end_date: this.state.dates.end_date
			}
		}else{
			newvalues = {
				start_date: this.state.dates.start_date,
				end_date: moment(value)
			}
		}
		return this.setState({
			dates: newvalues
		})
	}

	saveEntry(e) {
		e.preventDefault();
		this.props.addEntry(this.refs.place.value, {
			id: this.props.nextId,
			type: this.refs.type.value,
			name: this.refs.name.value,
			level: this.refs.level.value,
			start_date: moment(this.state.dates.start_date).format('YYYY-MM-DD'),
			end_date: moment(this.state.dates.end_date).format('YYYY-MM-DD'),
			description: this.state.description,
			offers: this.state.offers,
			objective: this.state.objective
		});
		_.map(this.refs, el => {
			switch (el.type) {
				case 'checkbox':
					return el.checked = false;
				case 'select-one':
					return el.value = 0;
				default:
					return el.value = '';
			}
		});
		return this.setState({
			dates: {
				start_date: undefined,
				end_date: undefined
			},
			offers: '',
			description: '',
			objective: []
		});
	}
}

export default ServiceDirectoryForm;


// WEBPACK FOOTER //
// ./src/cdm-frontend/elements/directory/service-form.jsx